module.exports = __webpack_public_path__ + "static/media/servicio_inversion_financiera.cbc8b226.jpg";